import React from 'react';
import { FadeIn } from './FadeIn';
import { Plane, BadgeCheck, Flame, Search, Handshake, Brain, Sparkles, Store } from 'lucide-react';
export function MarcaPrivadaIncluye() {
  const items = [{
    icon: Plane,
    title: 'Importación desde China',
    description: 'Curso paso a paso para importar tus productos desde China.'
  }, {
    icon: BadgeCheck,
    title: 'Proveedores verificables',
    description: 'Lista curada de proveedores confiables, listos para trabajar contigo.'
  }, {
    icon: Flame,
    title: 'Productos virales',
    description: 'Productos virales recomendados con potencial real de venta.'
  }, {
    icon: Search,
    title: 'Investigación avanzada',
    description: 'Sistema avanzado de investigación para validar antes de invertir.'
  }, {
    icon: Handshake,
    title: 'Negociación profesional',
    description: 'Método profesional para negociar mejores precios y condiciones.'
  }, {
    icon: Brain,
    title: 'IA para productos ganadores',
    description: 'Usa la Inteligencia Artificial para encontrar productos ganadores.'
  }, {
    icon: Sparkles,
    title: 'Prompts listos para usar',
    description: 'Plantillas de IA exclusivas — listas para copiar y aplicar.'
  }, {
    icon: Store,
    title: 'Multi-plataforma',
    description: 'Enfoque en Ecommerce, Shopify, TikTok Shop, Amazon y más.'
  }];
  return <section className="bg-brand-white py-20 md:py-28 px-5 sm:px-6 relative overflow-hidden" data-id="element-343">
      {/* Subtle background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-40" data-id="element-344">
        <div className="absolute -top-32 left-1/4 w-[500px] h-[500px] bg-brand-gold/5 rounded-full blur-3xl" data-id="element-345"></div>
        <div className="absolute -bottom-32 right-1/4 w-[500px] h-[500px] bg-brand-green/5 rounded-full blur-3xl" data-id="element-346"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-347">
        {/* Header */}
        <FadeIn data-id="element-348">
          <div className="text-center mb-14 md:mb-20 max-w-2xl mx-auto" data-id="element-349">
            <p className="text-xs sm:text-sm font-bold uppercase tracking-widest text-brand-gold mb-4 flex items-center justify-center gap-2" data-id="element-350">
              <Sparkles className="w-4 h-4" data-id="element-351" />
              Contenido del sistema
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold text-brand-green leading-[1.1] tracking-tight mb-5" data-id="element-352">
              Todo lo que incluye el sistema
              <span className="text-brand-gold align-super text-[0.4em] ml-0.5" data-id="element-353">
                ™
              </span>
            </h2>
            <p className="text-base md:text-lg text-brand-text/70 leading-relaxed" data-id="element-354">
              Un sistema completo diseñado para ayudarte a importar, crear tu
              marca y vender online de forma moderna y profesional.
            </p>
          </div>
        </FadeIn>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6" data-id="element-355">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <FadeIn key={index} delay={0.04 * (index % 8)} data-id="element-356">
                <div className="group h-full bg-white border border-brand-text/8 rounded-2xl p-6 md:p-7 shadow-[0_2px_20px_-8px_rgba(0,0,0,0.08)] hover:shadow-[0_20px_40px_-15px_rgba(28,57,40,0.18)] hover:-translate-y-1 hover:border-brand-gold/30 transition-all duration-300" data-id="element-357">
                  {/* Icon */}
                  <div className="w-12 h-12 rounded-xl bg-brand-green/8 group-hover:bg-brand-gold/15 flex items-center justify-center mb-4 transition-colors" data-id="element-358">
                    <Icon className="w-6 h-6 text-brand-green" strokeWidth={2} data-id="element-359" />
                  </div>

                  {/* Title */}
                  <h3 className="text-base md:text-lg font-bold text-brand-green mb-2 leading-snug" data-id="element-360">
                    {item.title}
                  </h3>

                  {/* Description */}
                  <p className="text-sm text-brand-text/65 leading-relaxed" data-id="element-361">
                    {item.description}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}